import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from "../../../../common/elements";
import { getSlotData } from '../../../../../actions/common/common';
import { JobView } from './elements';
import {
    getCurrentJob,
    resetCurrentJob,
    logExternal
} from '../../../../../actions/jobs/jobs';
import { postCVInterest } from '../../../../../actions/cvservice/cvservice';
import throttle from 'lodash/throttle';
import BackButton from "../../../../dashboardNew/components/tools/BackButton";
import * as jobsActions from "../../../../../actions/jobs/jobs";
import BreakBanner from "../../../../dashboardNew/components/BreakBanner";
import {browserHistory} from "react-router";
import {siteOfOriginHelper} from "../../../../../helpers/genericHelpers";

class JobItemFull extends Component {

    constructor() {
        super();
        this.state = {
            isPopupOpen: false,
            sticky: false
        };
    }

    componentDidMount() {
        window.scrollTo( 0, 0 );
        this.props.getCurrentJob( this.props.params.jobId );
    };

    componentWillUnmount() {
        this.props.resetCurrentJob();
        window.removeEventListener('scroll', this.scrollhandler)
    }

    handleRegisterInterest = () => {
        postCVInterest( localStorage.getItem('person_id') );
        this.setState({ isPopupOpen : true });
    };

    goBackHistory() {
        const curtain = document.getElementsByClassName('theme-curtain');
        curtain[0].classList.add('active');
        setTimeout(() => {
            window.scrollTo(0, 0);
            if( !window.previousPath ) {
                browserHistory.push('/jobs');
            } else {
                this.props.router.go(-1);
            }
        }, 500);
        setTimeout(() => {
            curtain[0].classList.remove('active');
        }, 1000);
    }


    render() {
        const siteOfOrigin = siteOfOriginHelper();
        if( !this.props.job || !Object.keys( this.props.job ).length ){ return <Loader /> };

        return (
            <article className="container-fluid jobs-full-view-body job-inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-12 job-inner-head">
                            <button className="theme-back-button clickable reverse-hover" onClick={() => this.goBackHistory()}>
                                <img src="/images/icons-new/left-arrow.svg" alt="back arrow" className="click-icon"/>
                                Back to Jobs Board
                            </button>
                        </div>
                    </div>
                </div>
                <JobView
                    job={ this.props.job }
                    logExternal={ id => this.props.logExternal( id ) }
                    registerInterest={ this.handleRegisterInterest }
                    addJobToFavourites={ this.props.addJobToFavourites }
                    removeJobFromFavourites={ this.props.removeJobFromFavourites }
                />
                {siteOfOrigin !== 'us' ? <BreakBanner
                    title="CV Services"
                    copy="Have you heard about our CV team?"
                    cta_text="Find out more"
                    cta_link="/writing-services"
                /> : ''}
            </article>
        );
    }
}

const mapStateToProps = state => ({
    job: state.jobs.current_job,
    sliderData: state.common.sliderData
});

const mapDispatchToProps = dispatch => ({
    getCurrentJob           : ( networkId, jobId ) => dispatch( getCurrentJob( networkId, jobId ) ),
    resetCurrentJob         : () => dispatch( resetCurrentJob() ),
    logExternal             : jobId => dispatch( logExternal( jobId ) ),
    getSlotData             : ( slotId, networkId, slider, addToSliderData, sponsorshipType ) => dispatch( getSlotData( slotId, networkId, slider, addToSliderData, sponsorshipType ) ),
    addJobToFavourites		: ( personId, jobId, index, skip ) => dispatch( jobsActions.addJobToFavourites( personId, jobId, index, skip ) ),
    removeJobFromFavourites	: ( personId, jobId, index, skip ) => dispatch( jobsActions.removeJobFromFavourites( personId, jobId, index, skip ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )( JobItemFull );



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobFullView.js